/* eslint-disable jsx-a11y/alt-text */
//PAQUETERIAS
import { useEffect, useState, useMemo, useRef } from "react";
import { StickyTable} from "react-sticky-table";
import {CustomDialog, Confirm} from "react-st-modal";
import NotificationSystem from 'react-notification-system';
//COMPONENTES
import AlertResponse from "../../main_components/alerts/alertResponse";
import MODAL_TABLE from "../../main_components/modal/modal_Table";
import { refresh_token  } from "../../main_components/tokens/tokenrefresh";
import { delete_roles, get_roles } from "../../services/configuration/configuration";
import TableContainer from "../../main_components/Table/TableContainer";
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";
import OPERATIONS_ROLES from "./tools/op_roles";
//ESTILOS
import "../../components_cfdi/estilo.css";
import '../../componentSociosNegocios/componentSectors/bonuses.css';
import "../../components_cfdi/modal.css";
import "./roles.css";
//IMAGENES/ICONOS
import Delete from "../../imgComponents/borrar.png";
import CREATE from "../../imgComponents/create.png";
import Edit from "../../imgComponents/save.png";


const TableRoles= () => {

  const notificationSystemRef = useRef();
  const [data, setData] = useState([]);
  const [open, setopen]=useState(false);
  var entrada=0;
  const [modalT, setmodalT] = useState(false);
  const [menssage, setmenssage] = useState("");
  const [modalGeneral, setmodalGeneral] = useState(false);

useEffect(()=>{
  handleSubmit();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[]);

function alertas(msj,status){

  if(status===true){
    notificationSystemRef.current.addNotification({
      message:<AlertResponse msj={msj} view={true}></AlertResponse>,
      level: 'success',
      position: 'br', 
      autoDismiss: 10, 
    });  
  }else{
    notificationSystemRef.current.addNotification({
      message:<AlertResponse msj={msj} view={false}></AlertResponse>,
      level: 'error',
      position: 'br', 
      autoDismiss: 60, 
    });
  }  
}
const reconsultar=(n)=>{
  if(n===true){
    setmodalT(true);  
  }else{
    setmodalT(false);
  } 
}
//proceso de consultar todos los ROLES
const handleSubmit = async () => {
    console.log("entra a consultar todos los roles");
      
    if(entrada===0){
      entrada=entrada+1;
      setmenssage("Consultando Roles...");
      setmodalGeneral(true);
      setmodalT(true);
    }else{
      setmodalT(true);
    }
    setopen(true);
    setData([]);

    try {
      var rf_token = await refresh_token();
      if(rf_token ===true){
        setTimeout(async() => {
          try{
            var d = await get_roles();
            setData(d === null ? [] : d.data.roles);  
            setopen(false);
            setmodalGeneral(false);
            setmodalT(false);  
          }catch(err){
            setData([]);
            setopen(false)
            setmodalGeneral(false);
            setmodalT(false);
          }     
        }, 1000);
      }else{}
    } catch (err) {
     console.log(err);
    }
};

const columns = useMemo(
  () => [
    {
      Header:()=>(
        <div>
          <img
            id="crearRol"
            src={CREATE}
            onClick={async () => {
              CustomDialog(               
             <div>
                <OPERATIONS_ROLES operation="CREATE" handleSubmit={handleSubmit} alertas={alertas} reconsultar={reconsultar}></OPERATIONS_ROLES>
             </div>,
           {
             className: "modalTItle",
             title:"Crear nuevo Rol",
             showCloseIcon: true,
             isCanClose:false,
           }
       );
     }}
            title="Crear Rol"
            className=""
          ></img>
        </div>
      ),
      
      id: "Acciones",
      Cell: ({ row }) => {
      const DeleteSector = async () => {  
      
      setmodalT(true);
      setData([]);
      setopen(true);
        try {
          var rf_token = await refresh_token();
          if(rf_token ===true){
            setTimeout(async() => {
              try{
                const dt = await delete_roles(row.original.id);
                console.log(dt);
                alertas("Rol Eliminado", true);
                handleSubmit();
              }catch(err){
                console.log("error", err);
                setopen(false);
                alertas("Error, no se pudo eliminar el Rol", false);
                setmodalT(false);
                handleSubmit();
              }
            }, 1000);
          }else{}
        } catch (err) {
          console.log(err);
        }
      }
        return (
          <div>
            <img
              src={Delete}
              onClick={async() =>{
                  const result = await Confirm('¿Esta usted seguro de eliminar el Rol?','Eliminar Roles','Si','No');
                  if(result){
                    DeleteSector()
                    }
                  }            
                }
              
              title="Eliminar Rol"
            ></img>
              &nbsp;
            <img
              src={Edit}
              onClick={
                async () => {
                  CustomDialog(               
                 <div>
                    <OPERATIONS_ROLES operation={"EDIT"} row={row} handleSubmit={handleSubmit} alertas={alertas} reconsultar={reconsultar}></OPERATIONS_ROLES>
                 </div>,
               {
                 className: "modalTItle",
                 title:"Editar Rol",
                 showCloseIcon: true,
                 isCanClose:false,
               }
           ); 
         }
        }
              
              title="Editar Rol"
            ></img>
          </div>
        );
      },
    },
    {
      Header: "Nombre del Rol",
      accessor:"name_role"
    },
    {
      Header: "Descripción del Rol",
      accessor: "description"
    }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
);
  return (
    <>
    <BREADCRUMBS niveles={
                [
                  {label: "CONSULTAR ROLES", path: null},
                ]
              }
      ></BREADCRUMBS>

<div className="TableRoles">
  <div >         
  <NotificationSystem  ref={notificationSystemRef} ></NotificationSystem>
  <MODAL_TABLE
    open={true}
    message={menssage}
    modalGeneral={modalGeneral}
    modalT={modalT}
  ></MODAL_TABLE>
          <>
         
          <StickyTable>
            <TableContainer
              paginado={"Roles"}
              consultas={"Roles Consultados"}
              exportar={true}
              columns={columns}
              data={data}
              style={{ overflowx: 10 }}
              Gmodal={open}
            />
          </StickyTable>
          </>   
          </div>
        </div>
    </>
  );
}

export default TableRoles;
